// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3ZDW1","dragIcon":"Choice_dragIcon__BWMfA","left":"Choice_left__3E3Ok","input":"Choice_input__1aIkH"};